<template>
  <Modal
    :visible="visible"
    :footer="null"
    :destroyOnClose="true"
    wrap-class-name="empty-modal"
    width="1000px"
    @ok="hide"
    @cancel="hide"
  >
    <div>
      <iframe
        :src="`${apiUrl}/custom-email/view/program?program_id=${this.$store.state.members.modalProgram}&token=${token}`"
        frameborder="0"
        width="100%"
        style="min-height: 75vh"
        title="preview email"
      ></iframe>
    </div>
  </Modal>
  <section class="members-invitation mt-6 lg:mt-8">
    <div class="w-full main-card px-3 md:px-4 lg:px-5 py-8">
      <Tabs class="w-full">
        <TabPane key="1" tab="New email">
          <h2 class="text-black">Send an email to members</h2>
          <RadioGroup v-model:value="checked">
            <Radio value="template">From a template</Radio>
            <Radio value="build">Build an email</Radio>
          </RadioGroup>
          <form @submit.prevent="handleSendInvitation">
            <CustumFileInput
              name="html_file"
              placeholder="choose html file"
              accept=".html, .htm, .hta, .shtml"
              v-if="checked == 'template'"
              :rules="{
                required: false,
                min: 1,
                max: 1,
              }"
              @setInput="setInput"
            >
              <PhFileHtml :size="22" weight="duotone" />
            </CustumFileInput>

            <Row class="my-2 gap-1">
              <!-- <Col span="24">
              <div class="flex  flex-col align-center">
                <p class="flex-inline">Send it on</p>
                <DatePicker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" :placeholder="['Date', 'Time']"
                  @change="onRangeChange">
                </DatePicker>
              </div>
              </Col> -->
              <Col span="11" class="m-auto">
                <DatePicker format="YYYY-MM-DD" class="w-full" @change="onRangeChangeDate" />
              </Col>
              <Col span="11" class="m-auto">
                <TimePicker
                  format="HH:mm"
                  class="w-full"
                  v-model:value="am8"
                  value-format="HH:mm"
                  @change="onRangeChangeTime"
                />
              </Col>
            </Row>
            <CustumInput
              style="width: 100%"
              name="title"
              :defaultData="null"
              :defaultError="null"
              label="Title"
              placeholder="Title"
              :rules="{
                required: true,
                min: 3,
              }"
              @setInput="setInput3"

            />
            <RadioGroup v-model:value="toRule" class="flex flex-col">
              <Radio value="all">All users</Radio>
              <Radio value="complete"
                >Users with complete registration (users completed the survey/registration)</Radio
              >
              <Radio value="incomplete">Users with incomplete registration</Radio>
            </RadioGroup>
            <Button class="block mt-3" htmlType="submit" block type="primary" :loading="loading">
              <div class="flex items-center justify-center gap-2">
                <span v-if="checked == 'template'">
                  <PhPaperPlaneTilt weight="duotone" size="18" />Save
                </span>
                <span v-if="checked == 'build'">
                  <PhBuildings weight="duotone" size="18" v-if="checked == 'build'" />Build
                </span>
              </div>
            </Button>
            <Alert v-if="error" type="error" :message="error" show-icon class="mt-3" />
          </form>
        </TabPane>

        <tab-pane key="2" tab="Scheduled emails">
          <CustomEmailsTable />
        </tab-pane>
        <tab-pane key="3" tab="Sent emails">
          <CustomSentEmailsTable />
        </tab-pane>
      </Tabs>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import {
  Input,
  InputGroup,
  Button,
  Alert,
  message,
  notification,
  Tabs,
  TabPane,
  Checkbox,
  Row,
  Col,
  Select,
  RangePicker,
  DatePicker,
  Modal,
  TimePicker,
  Radio,
  RadioGroup,
} from 'ant-design-vue';
import {
  PhPaperPlaneTilt,
  PhFileCsv,
  PhDownload,
  PhPaperPlaneRight,
  PhFileXls,
  PhFileHtml,
  PhBuildings,
} from 'phosphor-vue';

import CustumFileInput from '@/components/shared/form/CustumFileInput.vue';
import membersApi from '../../../services/apis/members.api';
import CustumSelect from '@/components/shared/form/CustumSelect.vue';
import CustomEmailsTable from './CustomEmailsTable.vue';
import { MEMBERS } from '@/store/types';
import { getToken } from '@/services/jwt.service';
import CustomSentEmailsTable from './CustomSentEmailsTable.vue';
import dayjs from 'dayjs';
import CustumInput from '@/components/shared/form/CustumInput.vue';

export default {
  components: {
    Input,
    InputGroup,
    Button,
    PhPaperPlaneTilt,
    CustumFileInput,
    PhFileCsv,
    PhDownload,
    Alert,
    PhPaperPlaneRight,
    Tabs,
    TabPane,
    PhFileXls,
    Checkbox,
    Row,
    Col,
    CustumSelect,
    Select,
    PhFileHtml,
    RangePicker,
    DatePicker,
    CustomEmailsTable,
    Modal,
    CustomSentEmailsTable,
    TimePicker,
    Radio,
    RadioGroup,
    PhBuildings,
    CustumInput
  },
  data() {
    return {
      email: '',
      name: '',
      loading: false,
      error: null,
      file: null,
      fileLoading: false,
      title:null,
      resData: null,
      when_to_send: null,
      when_to_send_date: null,
      when_to_send_time: '08:00',
      token: null,
      checked: 'template',
      toRule: 'all',
      am8: '08:00',
    };
  },
  created() {
    this.token = getToken();
  },
  computed: {
    visible() {
      return this.$store.state.members.modalView;
    },
    program() {
      return ``;
    },
    apiUrl() {
      return process.env.VUE_APP_API || 'https://dev.api.commutrics.com/api';
    },
    customEmailsQuery() {
      return this.$store.state.members.customEmailQuery;
    },
  },
  methods: {
    hide() {
      this.$store.commit(MEMBERS.SET_MODAL_VIEW, false);
    },
    async handleSendInvitation() {
      if (this.loading) {
        return;
      }

      if (!this.when_to_send_date || !this.when_to_send_time) {
        message.error('Please select When to send the email');
        return;
      }
      if (!this.title) {
        message.error('Please set a title');
        return;
      }
      const formData = new FormData();
      if (this.checked == 'template') formData.append('htmlFile', this.file);
      formData.append('when_to_send', `${this.when_to_send_date} ${this.when_to_send_time}`);
      formData.append('rule', this.toRule);
      formData.append('title', this.title);

      this.error = null;
      this.loading = true;

      try {
        const res = await membersApi.postCustomEmail(formData);
        this.$store.commit(MEMBERS.SET_MODAL_PROGRAM, res?.data?.id);
        this.$store.commit(MEMBERS.SET_MODAL_VIEW, true);
        message.success(res.result || 'Custom email was created successfully');
        if (this.customEmailsQuery) {
          this.customEmailsQuery.refetch();
        }
        this.loading = false;
        this.file = null;
        this.when_to_send = null;
      } catch (error) {
        // eslint-disable-next-line operator-linebreak
        this.error =
          error.response?.data?.message?.email[0] || error?.message || "Someting wen't wrong!";
        this.loading = false;
      }
    },

    onRangeChangeDate(value, dateString) {
      this.when_to_send_date = dateString;
    },
    onRangeChangeTime(value, dateString) {
      this.when_to_send_time = dateString;
    },


    setInput(val) {
      if (!val || !val.html_file || !val.html_file.value) return;
      // eslint-disable-next-line prefer-destructuring
      this.file = val.html_file.value[0] || null;
    },
    setInput2(val) {
      if (val?.when_to_send) {
        this.when_to_send = val?.when_to_send?.value;
      }
    },
    setInput3(val) {
      if (val?.title) {
        this.title = val?.title?.value;
      }
    },
  },
};
</script>
